import { useRecoilValue } from 'recoil';
import {
  useInterviewStages,
  useRejectedReasons
} from 'services/integration/hooks';
import { integrationAtom } from 'services/integration/atom';
import { isInterviewStageBasedRejection } from 'services/integration/utils';
import { CandidateStatus } from 'generated-graphql/types';

type UseAnalysisCandidateATSOptionsProps = {
  atsJobId: string | null | undefined;
  status: CandidateStatus;
};

export const useAnalysisCandidateATSOptions = ({
  atsJobId,
  status
}: UseAnalysisCandidateATSOptionsProps) => {
  const integration = useRecoilValue(integrationAtom);
  const useStagesForRejection = isInterviewStageBasedRejection(integration);

  const { rejectedReasons } = useRejectedReasons({ atsJobId });
  const { interviewStages } = useInterviewStages({ atsJobId });

  if (status === CandidateStatus.Rejected && !useStagesForRejection) {
    return {
      atsOptions: rejectedReasons.map((reason) => ({
        label: reason.label,
        value: reason.id
      })),
      interviewStages,
      rejectedReasons,
      useStagesForRejection
    };
  }

  return {
    atsOptions: interviewStages.map((stage) => ({
      label: stage.name,
      value: stage.id
    })),
    interviewStages,
    rejectedReasons,
    useStagesForRejection
  };
};
